"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.spaceHierarchySearcher = void 0;
var fuzzy_1 = __importDefault(require("fuzzy"));
// Filter a space hierarchy list by a given search phrase
function spaceHierarchySearcher(hierarchy, searchQuery) {
    if (searchQuery.length === 0) {
        return hierarchy;
    }
    return hierarchy.filter(function (item) {
        // It can either match the name of the space
        if (fuzzy_1.default.match(searchQuery, item.space.name)) {
            return true;
        }
        // Or the name of a parent higher up in the hierarchy.
        var parent = item.ancestry.find(function (ancestor) {
            return fuzzy_1.default.test(searchQuery, ancestor.name);
        });
        if (parent) {
            return true;
        }
        // Or the name of a child lower down in the hierarchy.
        return item.children.find(function (child) {
            return fuzzy_1.default.test(searchQuery, child.name);
        });
    });
}
exports.spaceHierarchySearcher = spaceHierarchySearcher;
//# sourceMappingURL=searcher.js.map